import React from "react"
import styled from "styled-components"
import { compose } from "ramda"
import { graphql } from "@apollo/client/react/hoc"
import Header from "../Header"
import PgaFooter from "../Footer"
import IsLoading from "./IsLoading"
import SaveSuccess from "../utils/SaveSuccess"
import { GET_LOADING } from "../queries/loading"
import { useModal } from "../Dashboard/JobSeekerDashboard/ModalContext"
import ProspectModal from "../Dashboard/JobSeekerDashboard/ProspectModal"
import BackgroundCheckModal from "../Dashboard/JobSeekerDashboard/BackgroundCheckModal"

const PageContainner = styled.section`
  flex-grow: 1;
`

const getIsLoading = graphql(GET_LOADING, {
  props: ({ data }) => {
    return {
      data,
      loading: data.loading,
    }
  },
})

export const Layout = ({ children, loading }) => {
  const { activeModal } = useModal()

  return (
    <div>
      <SaveSuccess />
      <Header />
      <IsLoading isLoading={loading} />
      <PageContainner>{children}</PageContainner>
      <PgaFooter />
      {activeModal === "prospect" && <ProspectModal />}
      {activeModal === "backgroundCheck" && <BackgroundCheckModal />}
    </div>
  )
}

export default compose(getIsLoading)(Layout)
